export default function SecondaryTabs({
    tabs,
    selectedIndex,
}: {
    tabs: {
        label: string,
        action: () => void,
        count?: number,
    }[],
    selectedIndex: number,
}) {
    return (
        <div className="flex justify-start items-center flex-wrap gap-4">
            {tabs.map((tab, i) => (
                <button 
                    onClick={tab.action}
                    className={`relative flex justify-center items-center gap-2 py-2 px-3 rounded-lg border hover:border-primary hover:text-primary transition-all ${selectedIndex === i ? 'border-primary bg-secondary text-primary font-medium' : 'border-outline bg-white/[0.3] text-default font-normal'}`}
                >
                    <p className={`text-[12px]`}>{tab.label}</p>
                    {tab.count !== undefined && (
                        <div className="px-[6px] py-[2px] rounded-xl bg-outline/[0.3] flex justify-center items-center">
                            <p className="text-[10px] text-default">{tab.count}</p>
                        </div>
                    )}
                </button>
            ))}
        </div>
    )
}